(function () {
  'use strict';

  class FormAssignmentDuoRoutesCtrl {
    constructor(safetyService, ServiceVfiltro, FactoryVfiltro, Authenticator, blockUI, $state) {
      this.authenticator = Authenticator;
      this.safetyService = safetyService;
      this.factoryVfiltro = FactoryVfiltro;
      this.serviceVfiltro = ServiceVfiltro;
      this.blockUI = blockUI;
      this.state = $state;

      this.user = null;

      this.initialize();
    }

    initialize() {
      this.blockUI.start();
      return this.initFilter()
        .then(() => this.loadUser())
        .then(() => this.loadReact())
        .finally(() => {
          this.blockUI.reset();
          this.blockUI.stop();
        });
    }

    initFilter() {
      return this.serviceVfiltro.init(
        this.factoryVfiltro.get([])
      );
    }

    loadUser() {
      return this.authenticator.getUser()
        .then((user) => {
          this.user = user;
        });
    }

    loadReact() {
      const appName = 'safetyApp',
          componentName = './DuoRouteAssignmentFormPage',
          componentId = 'safety-duo-route-assignment-form',
          props = this.getReactProps();

      return this.safetyService
        .initialize()
        .then(() => this.safetyService.loadReactComponent(appName, componentName, componentId, props));
    }

    goBackToList() {
      this.state.go('root.duo-routes-atribuicao');
    }

    getReactProps() {
      return {
        user: this.user,
        goBackToList: () => this.goBackToList()
      };
    }
  }

  angular
    .module('duo-routes.atribuicao-rotas')
    .controller('FormAssignmentDuoRoutesCtrl', FormAssignmentDuoRoutesCtrl);
}());
